module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?63b125eca92f2f7ba0e9f6594d7d8c6f";